<template>
  <v-row>
    <v-col cols="12">
      <cpanel_launch :hostingid="hosting.id"/>
    </v-col>
  </v-row>
</template>

<script>
import cpanel_launch from '@/components/Services/Hosting/Common/HostingCpanelLaunch'
import { mapGetters } from 'vuex'

export default {
  name: 'CpanelLaunchView',
  components: { cpanel_launch },
  computed: {
    ...mapGetters(['hosting'])
  }
}
</script>
